import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { DatacontextService } from '../../../../data/datacontext.service';

@Component({
  selector: 'app-cb-checkout-dialog',
  templateUrl: './cb-checkout-dialog.component.html',
  styleUrls: ['./cb-checkout-dialog.component.scss']
})
export class CbCheckoutDialogComponent implements OnInit {

  productionAppsCount: number;
  productionSlotCount: number;
  freeLiveSlotCount: number;
  blockReduceQty = false;
  newSlotCount = this.productionSlotCount;

  constructor(
    private dialogRef: MatDialogRef<CbCheckoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datacontextService: DatacontextService) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.datacontextService.chargebee.getProductionAppsAndSlotsCount().subscribe((data: any) => {
      this.productionSlotCount = data['slots'];
      this.newSlotCount = this.productionSlotCount;

      this.productionAppsCount = data['apps'];
      if (this.productionSlotCount === -1 ) {
        this.freeLiveSlotCount = 1;
      } else {
        this.freeLiveSlotCount = this.productionSlotCount - this.productionAppsCount;
      }
    });
  }

  getAbsValue(num) {
    return Math.abs(num);
  }


  updateNewSlotCount(amt) {
    if ( this.newSlotCount <= this.productionAppsCount && amt === -1) {
      this.blockReduceQty = true;
      return;
    }
    this.blockReduceQty = false;
    this.newSlotCount += amt;
    this.data.qty = this.newSlotCount;
  }

}
